import { redirectEnum } from './constants';
import { normalizeCnpj } from './validations';

export const moneyFormatter = (amount: number | null) => {
  if (!amount) return '';
  const amountFixed = amount.toFixed(2).replace('.', ',');
  const amountSliced = amountFixed.split(',');
  return `R$ ${amountSliced[0].replace(/\d+?(?=(?:\d{3})+$)/gim, '$&.')},${amountSliced[1]
    }`;
};

export const urlFormatter = (path: string) => {
  const pathWithoutId = path.includes('manutencao')
    ? path
    : path.replace(/^(\/[^/]+\/[^/]+).*$/, '$1');

  switch (pathWithoutId) {
    case '/inicio':
      return 'Início';
    case '/relatorios/modelos':
      return 'Modelos';
    case '/relatorios/distdefrotas':
      return 'Distribuição da Frota';
    case '/relatorios/manutencao/entradasaida':
      return 'Entrada e Saída';
    case '/relatorios/manutencao/avarias':
      return 'Avarias';
    case '/relatorios/manutencao/servicos':
      return 'Serviços';
    case '/relatorios/manutencao/preventivas':
      return 'Preventivas';
    case '/relatorios/disponibilidade':
      return 'Disponibilidade';
    case '/relatorios/distribuicaodafrota':
      return 'Distribuição da Frota';
    case '/agendamentos':
      return 'Agendamentos';
    case '/novo-chamado':
      return 'Novo Chamado';
    case '/novo-chamado/lote':
      return 'Agendamento em lote';
    case '/chamados':
      return 'Central de Chamados';
    case '/servicos-manutencao':
      return 'Serviços de Manutenções';
    case '/novo-agendamento/veiculos':
    case '/novo-agendamento/servicos':
    case '/novo-agendamento/agenda':
    case '/novo-agendamento/lote':
    case '/novo-agendamento/revisao':
    case '/novo-agendamento/imagens':
      return 'Novo Agendamento';
    case '/faturamento':
      return 'Faturamento';
    case '/faturamento/mediacao':
      return 'Mediação';
    case '/acessos':
      return 'Acessos';
    case '/acessos/usuario':
      return 'Criação de usuário';
    case '/centraldeduvidas':
      return 'Canais de atendimento';
    case '/centraldeduvidas/pergunta':
      return 'Pergunta';
    case '/centraldeduvidas/pergunta/criar':
      return 'Criar pergunta';
    case '/centraldeduvidas/pergunta/editar':
      return 'Editar pergunta';
    case '/centraldeduvidas/lista':
      return 'Lista de perguntas';
    case '/centraldeduvidas/editarcategorias':
      return 'Editar categorias';
    case '/gestaodecontratos':
      return 'Gestão de contratos';
    case '/gestaodecontratos/contrato':
      return 'Contrato';
    case '/administrativo/logs':
      return 'Logs';
    case '/administrativo/logspdv':
      return 'Logs Pdv';
    case '/gestao/veiculos':
      return 'Veículos';
    case '/gestao/cobrancas':
      return 'Cobranças';
    case '/gestao/multas':
      return 'Multas';
    case '/gestao/multa':
      return 'Indicar condutor';
    case '/administrativo/comunicados':
      return 'Comunicados';
    case '/administrativo/comunicados/comunicado':
      return 'Comunicado';
    case '/gestao/acessoMultas':
      return 'acessoMultas';
    default:
      return '';
  }
};

export const maskPhone = (phone: string) => {
  phone = phone.replace(/\D/g, '');

  phone = phone.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');

  return phone;
};

export const formatCnpj = (cnpj: string | null | undefined) => {
  if (!cnpj) return '';

  const cleaned = normalizeCnpj(cnpj).slice(0, 14);

  if (cleaned.length !== 14 || !/^[A-Z0-9]{12}\d{2}$/.test(cleaned)) {
    return cnpj;
  }

  return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(
    5,
    8,
  )}/${cleaned.slice(8, 12)}-${cleaned.slice(12)}`;
};

export const actionFormatter = (action: string) => {
  switch (action) {
    case 'Criou conteúdo':
      return '2';
    case 'Alterou conteúdo':
      return '4';
    case 'Deletou conteúdo':
      return '8';
    case 'Cancelamento':
      return '16';
    case 'Baixou conteúdo':
      return '32';
    case 'Aprovação Fatura':
      return '64';
    case 'Contestação Fatura':
      return '128';
  }
};

export const sectionFormatter = (action: string) => {
  switch (action) {
    case 'Agendamento':
      return '0';
    case 'Central de Ajuda':
      return '1';
    case 'Faturamento':
      return '2';
    case 'CRLV':
      return '3';
  }
};

export const handleCustomUrl = (title: string) => {
  return title.trim().replace(/[^\w\s]/gi, '');
};

export const getPageInfoById = (id: number | string) => {
  const page = redirectEnum[Number(id)];
  return page ? page : { title: 'Página não encontrada', route: '/' };
};

export const isPlate = (text: string) => {
  const pattern = /^[A-Z]{3}(-?\d{4}|\d[A-Z]\d{2})$/i;
  return pattern.test(text);
};

export const formatPlate = (text: string) => {
  const cleaned = text.toUpperCase().replace(/[^A-Z0-9]/g, '');

  if (cleaned.length === 7) {
    if (/^\d{4}$/.test(cleaned.slice(3))) {
      return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
    } else if (/^\d[A-Z]\d{2}$/.test(cleaned.slice(3))) {
      return `${cleaned.slice(0, 3)}-${cleaned[3]}${cleaned[4]}${cleaned.slice(
        5,
      )}`;
    }
  }

  return text;
};
